// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"support_wrapper__jYUl9","text":"support_text__37Gwf"};